import { render, staticRenderFns } from "./IconMenuBroadcast.vue?vue&type=template&id=bccadfa4"
import script from "./IconMenuBroadcast.vue?vue&type=script&lang=js"
export * from "./IconMenuBroadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports